module.exports = "<div class=\"loading-bar\" [class.active]=\"loading.active\" [class.bottom]=\"bottom\" [class.fixed]=\"fixed\"></div>\n"